import intl from 'react-intl-universal';

const i18nConfig = {
    locale: 'de',
    messages: {
        "required": "Pflichtfeld",

        "admin.logout": "Abmelden",
        "general.reload": "Tabelle neu laden",

        "menus.dashboard": "Übersicht",
        "menus.deviceManagement": "Geräteverwaltung",
        "menus.alerts": "Alarme",
        "menus.pairingModes": "Pairing Modes",
        "menus.pairings": "Pairings",
        "menus.devices": "Geräte",
        "menus.configurations": "Konfigurationen",
        "menus.journals": "Journale",
        "menus.measurements": "Messungen",
        "menus.events": "Ereignisse",
        "menus.syncs": "Heartbeat",
        "menus.commands": "Befehle",
        "menus.reports": "Berichte",
        "menus.organization": "Organisation",
        "menus.user": "Benutzer",
        "menus.tenantManagement": "Kundenverwaltung",
        "menus.leases": "Mieten",
        "menus.tenants": "Kunden",
        "menus.buildings": "Gebäude",
        "menus.parcels": "Wohnungen",
        "menus.taps": "Anschlüsse",
        "menus.lateDevices": "Überfällige Geräte",
        "menus.qualityDevices": "Auffällige Messungen",
        "menus.deviceStatus": "Gerätestatus",
        "menus.deviceFindings": "Auffälligkeiten",
        

        "dashboard.nextSteps": "Wussten Sie schon?",
        "dashboard.grid.1.h2": "Pairing",
        "dashboard.grid.1.p": "Versetzen Sie einfach den Server in den Pairing Modus",
        "dashboard.grid.1.button": "Zum Pairing Modus",
        "dashboard.grid.1.button.menuIndex": "1",
        "dashboard.grid.1.button.entriesIndex": "1",
        "dashboard.grid.2.h2": "Geräte",
        "dashboard.grid.2.p": "Zeigen Sie sich alle Geräte bequem an",
        "dashboard.grid.2.button": "Zu den Geräten",
        "dashboard.grid.2.button.menuIndex": "1",
        "dashboard.grid.2.button.entriesIndex": "3",
        "dashboard.grid.3.h2": "Spülungen",
        "dashboard.grid.3.p": "Zeigen Sie sich alle Messungen bequem an",
        "dashboard.grid.3.button": "Zu den Messungen",
        "dashboard.grid.3.button.menuIndex": "1",
        "dashboard.grid.3.button.entriesIndex": "7",

        "alerts.device": "Gerät",
        "alerts.cause": "Auslöser",
        "alerts.created": "Aufgetreten am",
        "alerts.site": "Geräte-Standort",
        "alerts.status": "Status",
        "alerts.status.new": "offen",
        "alerts.status.done": "erledigt",
        "alerts.id": "ID",
        "alerts.markDone": "Als erledigt markieren",
        "alerts.message.markDone.success": "Alarm als erledigt markiert",
        "alerts.message.markDone.error": "Es ist ein Fehler aufgetreten. Beachten Sie die weiteren Hinweise",

        "pairingModes.title": "Pairing Modes",
        "pairingModes.unlock": "Server entsperren",
        "pairingModes.lock": "Server sperren",
        "pairingModes.message.unlock.success": "Server wurde erfolgreich entsperrt",
        "pairingModes.message.lock.success": "Server wurde erfolgreich gesperrt",
        "pairingModes.message.unlock.error": "Es ist ein Fehler aufgetreten. Beachten Sie die weiteren Hinweise",
        "pairingModes.message.lock.error": "Es ist ein Fehler aufgetreten. Beachten Sie die weiteren Hinweise",
        "pairingModes.dialog.lockDialog.title": "Entsperrdauer festlegen",
        "pairingModes.dialog.lockDialog.label": "Server entsperren bis",
        "pairingModes.dialog.lockDialog.confirm": "OK",
        "pairingModes.dialog.lockDialog.todayLabel": "Heute",
        "pairingModes.dialog.lockDialog.cancel": "Abbrechen",
        "pairingModes.valid": "Gültig",
        "pairingModes.starts": "Gültig ab",
        "pairingModes.ends": "Gültig bis",
        "pairingModes.id": "ID",

        "pairings.uuid": "Gerät",
        "pairings.imei": "IMEI",
        "pairings.created": "Erstellt am",
        "pairings.pairMode": "Pairing Mode",
        "pairings.id": "ID",

        "devices.title": "Geräte",
        "devices.id": "ID",
        "devices.uuid": "UUID",
        "devices.imei": "IMEI",
        "devices.status": "Status",
        "devices.notes": "Notizen",
        "devices.storage": "Lagerort",
        "devices.status.LEASED": "vermietet",
        "devices.status.DEFECTIVE": "defekt",
        "devices.status.MAINTENANCE": "in Reparatur",
        "devices.status.STOCKED": "im Lager",
        "devices.status.ASSEMBLY": "in Montage",
        "devices.timestampOfLastMeasurement": "letzte Messung am",
        "devices.lastRssi": "letzte Signalstärke",
        "devices.lastSignal": "Signalstärke in %",
        "devices.lastBattery": "letzter Batteriezustand",
        "devices.last3Events": "letzte 3 Ereignisse",
        "devices.lastFirmware": "letzte Firmware",
        "devices.nextFlush": "Nächste Spülung am",
        "devices.version": "Version",
        "devices.sWait": "sWait",
        "devices.mlMin": "mlMin",
        "devices.mlMax": "mlMax",
        "devices.msMin": "msMin",
        "devices.msMax": "msMax",
        "devices.mmMax": "mmMax",
        "devices.threshold": "threshold",
        "devices.ringBuffer": "ringBuffer",
        "devices.msLog": "msLog",
        "devices.created": "created",
        "devices.endpoints": "endpoints",
        "devices.dialog.configView.property": "Feld",
        "devices.dialog.configView.value": "Wert",
        "devices.dialog.configView.title": "Konfiguration für Gerät",
        "devices.dialog.configView.cancel": "Schließen",
        "devices.dialog.deviceDetails.title": "Informationen zum Gerät",
        "devices.dialog.deviceDetails.cancel": "Schließen",
        "devices.dialog.findings.title": "Auffälligkeiten von Gerät",
        "devices.dialog.findings.cancel": "Schließen",
        "devices.dialog.findings.ref": "Gerät",
        "devices.dialog.findings.type": "Auffälligkeit",
        "devices.dialog.findings.created": "Aufgetreten am",
        "devices.dialog.findings.details": "Details",
        "devices.message.onRowUpdate.success": "Gerät wurde erfolgreich angepasst",
        "devices.message.onRowUpdate.error": "Es ist ein Fehler aufgetreten. Beachten Sie die weiteren Hinweise",
        "devices.configView": "Konfiguration anzeigen",
        "devices.deviceDetails": "Geräte-Details anzeigen",
        "devices.deviceFindings": "Geräte-Auffälligkeiten anzeigen",
        "devices.address": "Standort",

        "deviceDetails.address": "Adresse",
        "deviceDetails.empty": " ",
        "deviceDetails.firmware": "letzte Firmware",
        "deviceDetails.lastFlushMs": "letzte Spülmenge in ml",
        "deviceDetails.lastFlushMl": "letzte Spüldauer in ms",
        "deviceDetails.lastFlushAmbient": "letzte Umgeb. Temp. °C",
        "deviceDetails.nextFlush": "nächste Spülung am",
        "deviceDetails.leaseStarts": "Beginn Vertrag",
        "deviceDetails.leaseEnds": "Ende Vertrag",
        "deviceDetails.tap": "Anschluss",
        "deviceDetails.tenant": "Kunde",
        "deviceDetails.status": "Gerätestatus",

        "devicesStatusReport.h2": "Geräte nach Status",
        "devicesFindingsReport.h2": "Auffälligkeiten nach Typ",

        "configurations.title": "Konfigurationen",
        "configurations.id": "ID",
        "configurations.device": "Gerät",
        "configurations.version": "Version",
        "configurations.endpoints": "API-Endpunkte",
        "configurations.freq": "Frequenz",
        "configurations.mlMax": "max. Menge in ml",
        "configurations.mlMin": "min. Menge in ml",
        "configurations.mmMax": "Abstand max in mm",
        "configurations.msLog": "Logdauer in ms",
        "configurations.msMax": "max. Dauer in ms",
        "configurations.msMin": "min. Dauer in ms",
        "configurations.ringBuffer": "Länge Ringbuffer",
        "configurations.sWait": "Nächste Spülung in s",
        "configurations.sHeartbeat": "Heartbeat Intervall in s",
        "configurations.threshold": "Grenzwert",
        "configurations.created": "Erstellt am",
        "configurations.addConfiguration.tooltip": "Neue Konfiguration erstellen",
        "configurations.error.validation": "Es sind nicht alle Daten eingegeben oder Daten entsprechen nicht dem benötigten Format.",
        "configurations.message.onAdd.success": "Konfiguration wurde erfolgreich angelegt",
        "configurations.message.onAdd.error": "Es ist ein Fehler aufgetreten. Beachten Sie die weiteren Hinweise",

        "configurationWizard.title": "Konfiguration erstellen",
        "configurationWizard.cancel": "Abbrechen",
        "configurationWizard.next": "Weiter",
        "configurationWizard.previous": "Zurück",
        "configurationWizard.save": "Speichern",
        "configurationWizard.step.0": "Vorlage auswählen",
        "configurationWizard.step.1": "Konfiguration bearbeiten",
        "configurationWizard.step.2": "Zusammenfassung",

        "journals.title": "Journale",
        "journals.id": "ID",
        "journals.device": "Gerät",
        "journals.firmware": "Firmware-Version",
        "journals.created": "Übertragen am",

        "measurements.title": "Messungen",
        "measurements.id": "ID",
        "measurements.device": "Gerät",
        "measurements.created": "Gespült am",
        "measurements.ml": "Menge in ml",
        "measurements.ms": "Dauer in ms",
        "measurements.points": "Anzahl Messpunkte",
        "measurements.cAmbient": "Umgebungstemperatur",
        "measurements.rh": "relative Luftfeuchte",
        "measurements.battery": "Akkustatus",
        "measurements.network": "Netzwerk",
        "measurements.rssi": "Signalstärke",
        "measurements.signal": "Signalstärke in %",
        "measurements.test": "Testspülung",
        "measurements.dialog.graphDialog.title": "Abstandsmessung von Gerät",
        "measurements.dialog.graphDialog.cancel": "Schließen",
        "measurements.graphDialog": "Abstandsmessung für Spülung anzeigen",

        "events.title": "Ereignisse",
        "events.id": "ID",
        "events.device": "Gerät",
        "events.code": "Ereignis",
        "events.created": "Aufgetreten am",
        "events.code.FLUSH": "Gespült",
        "events.code.RESET": "Zurückgesetzt",
        "events.code.RESTART": "Neustart",
        "events.code.DUMP": "Dump",
        "events.code.UPDATE": "Aktualisiert",
        "events.code.PAIR": 'Gepair`ed',
        "events.code.DISTANCE_ERROR": "Abstandsfehler",
        "events.code.FLOW_ERROR": "Verstopft",
        "events.code.OUTOFBOUNDS_ERROR": "Überlauf-Stop",
        "events.code.INBOUND_TEMPERATURE": "Temperatur konstant",
        
        "events.code.BATTERY_LOW": "Batterie schwach",
        "events.code.SERVER_ERROR": "Serverfehler",
        "events.code.UPDATE_ERROR": "Aktualisierungsfehler",
        "events.code.GENERAL_ERROR": "Allgemeiner Fehler",
        "events.code.NETWORK_ERROR": "Netzwerkfehler",
        "events.code.SENSOR_ERROR_FLOW": "Durchflusssensor",
        "events.code.SENSOR_ERROR_DISTANCE": "Abstandssensor",
        "events.code.SENSOR_ERROR_TEMPERATURE": "Temperatursensor",
        "events.code.VALVE_ERROR": "Ventil-Fehler",

        "syncs.id": "ID",
        "syncs.device": "Gerät",
        "syncs.firmware": "Firmware",
        "syncs.rh": "relative Luftfeuchte",
        "syncs.created": "Erstellt am",
        "syncs.pressure": "Druck liegt an",
        "syncs.temperature": "Temperatur",

        "commands.title": "Ereignisse",
        "commands.id": "ID",
        "commands.device": "Gerät",
        "commands.status": "Status",
        "commands.status.NEW": "Neu",
        "commands.status.SENT": "Ans Gerät übertragen",
        "commands.status.DONE": "Bestätigt",
        "commands.type": "Art",
        "commands.type.RESET": "Zurücksetzen",
        "commands.type.DUMP": "DUMP",
        "commands.type.RESTART": "Neustart",
        "commands.type.UPDATE": "Aktualisieren",
        "commands.configuration": "Version der Konfiguration",
        "commands.created": "Aufgetreten am",

        "reports.title": "Berichte",
        "reports.grid.1.h1": "Geräte",
        "reports.grid.1.p": "Alle Geräte nach Status",
        "reports.grid.2.h1": "Auffälligkeiten",
        "reports.grid.2.p": "Alle Auffälligkeiten nach Typ",

        "leases.title": "Mieten",
        "leases.id": "ID",
        "leases.device": "Gerät",
        "leases.tenant": "Kunde",
        "leases.street": "Adresse",
        "leases.building": "Gebäude",
        "leases.status": "Status",
        "leases.tap": "Anschluss",
        "leases.parcel": "Wohnung",
        "leases.starts": "Beginn",
        "leases.ends": "Ende",
        "leases.notes": "Notizen",
        "leases.status.RUNNING": "Läuft",
        "leases.status.DONE": "Abgelaufen",
        "leases.status.PENDING": "Ausstehend",
        "leases.addLease.tooltip": "Miete aufsetzen",
        "leases.exchangeDevice": "Gerät austauschen",
        
        "leases.message.onAdd.success": "Miete wurde erfolgreich hinzugefügt",
        "leases.message.onAdd.error": "Es ist ein Fehler aufgetreten. Beachten Sie die weiteren Hinweise",
        "leases.message.onRowUpdate.success": "Miete wurde erfolgreich angepasst",
        "leases.message.onRowUpdate.error": "Es ist ein Fehler aufgetreten. Beachten Sie die weiteren Hinweise",
        "leases.message.onRowDelete.success": "Miete wurde erfolgreich gelöscht",
        "leases.message.onRowDelete.error": "Es ist ein Fehler aufgetreten. Beachten Sie die weiteren Hinweise",
        "leases.message.onExchangeDevice.success": "Miete wurde erfolgreich angepasst",
        "leases.message.onExchangeDevice.error": "Es ist ein Fehler aufgetreten. Beachten Sie die weiteren Hinweise",

        "leaseWizard.title": "Miete aufsetzen",
        "leaseWizard.cancel": "Abbrechen",
        "leaseWizard.next": "Weiter",
        "leaseWizard.previous": "Zurück",
        "leaseWizard.save": "Speichern",
        "leaseWizard.starts.label": "Mietbeginn",
        "leaseWizard.ends.label": "Mietende",
        "leaseWizard.step.0": "Gerät auswählen",
        "leaseWizard.step.1": "Mieter auswählen",
        "leaseWizard.step.2": "Gebäude auswählen",
        "leaseWizard.step.3": "Wohnung auswählen",
        "leaseWizard.step.4": "Anschluss auswählen",
        "leaseWizard.step.5": "Status setzen",
        "leaseWizard.step.6": "Mietdauer festlegen",
        "leaseWizard.step.7": "Notizen",
        "leaseWizard.step.8": "Zusammenfassung",
        "leaseWizard.summary.device": "Gerät",
        "leaseWizard.summary.tenant": "Mieter",
        "leaseWizard.summary.building": "Gebäude",
        "leaseWizard.summary.parcel": "Wohnung",
        "leaseWizard.summary.tap": "Anschluss",
        "leaseWizard.summary.status": "Status",
        "leaseWizard.summary.notes": "Notizen",
        "leaseWizard.summary.duration": "Mietdauer",

        "exchangeDevice.step.0": "Gerät auswählen",
        "exchangeDevice.step.1": "Austausch-Datum festlegen",
        "exchangeDevice.step.2": "Status des Altgeräts setzen",
        "exchangeDevice.step.3": "Zusammenfassung",
        "exchangeDevice.summary.device": "Gerät",
        "exchangeDevice.summary.exchangeDate": "Austausch-Datum",
        "exchangeDevice.summary.oldDeviceStatus": "Status des Altgeräts",
        
        "exchangeDevice.exchangeDate.label": "Datum",

        "exchangeDevice.title": "Gerätezuweisung ändern",
        "exchangeDevice.cancel": "Abbrechen",
        "exchangeDevice.next": "Weiter",
        "exchangeDevice.previous": "Zurück",
        "exchangeDevice.save": "Speichern",

        "dateTimePicker.cancelLabel": "Abbrechen",
        "dateTimePicker.okLabel": "Übernehmen",
        "dateTimePicker.todayLabel": "Heute",
        "dateTimePicker.minDateMessage": "Das ausgewählte Mietende liegt vor dem Mietbeginn",
        'dateTimePicker.starts': 'Startdatum',
        'dateTimePicker.ends': 'Enddatum',
        'dateTimePicker.minDateMessage': 'Zeitpunkt liegt vor dem eingestellten Minimum',
        

        "tenants.name": "Anprechpartner",
        "tenants.reference": "Referenznummer",
        "tenants.street": "Straße",
        "tenants.zipCode": "Postleitzahl",
        "tenants.place": "Ort",
        "tenants.phone": "Telefon",
        "tenants.id": "Kundennummer",
        "tenants.company": "Kunde",
        "tenants.receives_email": "Erhält Emails",
        "tenants.admin": "Administrator-Email",
        "tenants.admin.tooltip": "Erhält automatisierte Emails im Fehlerfall",
        "tenants.contact": "Kontakt-Email",
        "tenants.contact.tooltip": "Erhält automatisierte Emails mit Spülprotkollen",
        "tenants.device.uuid": "Gerät",
        "tenants.device.imei": "imei",
        "tenants.error.validation": "Es sind nicht alle Daten eingegeben oder Daten entsprechen nicht dem benötigten Format.",
        "tenants.message.onRowAdd.success": "Kunde wurde erfolgreich angelegt",
        "tenants.message.onRowAdd.error": "Es ist ein Fehler aufgetreten. Beachten Sie die weiteren Hinweise",
        "tenants.message.onRowUpdate.success": "Kunde wurde erfolgreich angepasst",
        "tenants.message.onRowUpdate.error": "Es ist ein Fehler aufgetreten. Beachten Sie die weiteren Hinweise",
        "tenants.message.onRowDelete.success": "Kunde wurde erfolgreich gelöscht",
        "tenants.message.onRowDelete.error": "Es ist ein Fehler aufgetreten. Beachten Sie die weiteren Hinweise",
        "tenants.message.onRowDelete.notEmpty": "Diesem Kunden sind noch Gebäude zugewiesen, bitte bearbeiten oder löschen Sie erst diese Gebäude",

        "buildings.title": "Gebäude",
        "buildings.street": "Adresse",
        "buildings.tenant": "Eigentümer",
        "buildings.trustee": "Verwalter",
        "buildings.id": "ID",
        "buildings.parcel": "Wohnungsnummer/Lage",
        "buildings.parcel.id": "ID",
        "buildings.place": "Ort",
        "buildings.zipCode": "Postleitzahl",
        "buildings.reference": "GebäudeID",
        "buildings.message.onRowAdd.success": "Gebäude wurde erfolgreich angelegt",
        "buildings.message.onRowAdd.error": "Es ist ein Fehler aufgetreten. Beachten Sie die weiteren Hinweise",
        "buildings.message.onRowUpdate.success": "Gebäude wurde erfolgreich angepasst",
        "buildings.message.onRowUpdate.error": "Es ist ein Fehler aufgetreten. Beachten Sie die weiteren Hinweise",
        "buildings.message.onRowDelete.success": "Gebäude wurde erfolgreich gelöscht",
        "buildings.message.onRowDelete.error": "Es ist ein Fehler aufgetreten. Beachten Sie die weiteren Hinweise",
        "buildings.error.validation": "Es sind nicht alle Daten eingegeben oder Daten entsprechen nicht dem benötigten Format.",
        "buildings.message.onRowDelete.notEmpty": "Diesem Gebäude sind noch Wohnungen zugewiesen, bitte bearbeiten oder löschen Sie erst diese Wohnungen",

        "parcels.name": "Wohnungsnummer/Lage",
        "parcels.id": "ID",
        "parcels.building": "In Gebäude",
        "parcels.index": "Wohnungsnummer",
        "parcels.shortName": "Kürzel",
        "parcels.reference": "Referenznummer",
        "parcels.message.onRowAdd.success": "Wohnung wurde erfolgreich angelegt",
        "parcels.message.onRowAdd.error": "Es ist ein Fehler aufgetreten. Beachten Sie die weiteren Hinweise",
        "parcels.message.onRowUpdate.success": "Wohnung wurde erfolgreich angepasst",
        "parcels.message.onRowUpdate.error": "Es ist ein Fehler aufgetreten. Beachten Sie die weiteren Hinweise",
        "parcels.message.onRowDelete.success": "Wohnung wurde erfolgreich gelöscht",
        "parcels.message.onRowDelete.error": "Es ist ein Fehler aufgetreten. Beachten Sie die weiteren Hinweise",
        "parcels.error.validation": "Es sind nicht alle Daten eingegeben oder Daten entsprechen nicht dem benötigten Format.",
        "parcels.message.onRowDelete.notEmpty": "Dieser Wohnung sind noch Anschlüsse zugewiesen, bitte bearbeiten oder löschen Sie erst diese Anschlüsse",
        "parcels.taps.name": "Anschluss",
        "parcels.taps.id": "ID",

        "taps.id": "ID",
        "taps.name": "Lage",
        "taps.valve": "Anschluss",
        "taps.faucet": "Armatur",
        "taps.building": "in Gebäude",
        "taps.parcel": "in Wohnung",
        "taps.tenant": "Kunde",
        "taps.message.onAdd.success": "Anschluss wurde erfolgreich angelegt",
        "taps.message.onAdd.error": "Es ist ein Fehler aufgetreten. Beachten Sie die weiteren Hinweise",
        "taps.message.onRowUpdate.success": "Anschluss wurde erfolgreich angepasst",
        "taps.message.onRowUpdate.error": "Es ist ein Fehler aufgetreten. Beachten Sie die weiteren Hinweise",
        "taps.message.onRowDelete.success": "Anschluss wurde erfolgreich gelöscht",
        "taps.message.onRowDelete.error": "Es ist ein Fehler aufgetreten. Beachten Sie die weiteren Hinweise",
        "taps.error.validation": "Es sind nicht alle Daten eingegeben oder Daten entsprechen nicht dem benötigten Format.",
        "taps.message.onRowDelete.notEmpty": "Dieser Anschluss ist noch einem Gerät zugewiesen, bitte bearbeiten oder löschen Sie erst diese Miete",
        "taps.addTap.tooltip": "Neuen Anschluss anlegen",

        "tapWizard.title": "Anschluss anlegen",
        "tapWizard.cancel": "Abbrechen",
        "tapWizard.next": "Weiter",
        "tapWizard.previous": "Zurück",
        "tapWizard.save": "Speichern",
        "tapWizard.step.0": "Zimmer eingeben",
        "tapWizard.step.1": "Anschluss eingeben",
        "tapWizard.step.2": "Armaturtyp eigeben",
        "tapWizard.step.3": "Kunden auswählen",
        "tapWizard.step.4": "Gebäude auswählen",
        "tapWizard.step.5": "Wohnung auswählen",
        "tapWizard.step.6": "Zusammenfassung",
        "tapWizard.summary.room": "Zimmer",
        "tapWizard.summary.tenant": "Mieter",
        "tapWizard.summary.building": "Gebäude",
        "tapWizard.summary.parcel": "Wohnung",
        "tapWizard.summary.valve": "Anschluss",
        "tapWizard.summary.faucet": "Armatur",

        "users.title": "Benutzer",
        "users.id": "ID",
        "users.email": "E-Mail-Adresse",
        "users.displayName": "Name",
        "users.roles": "Rollen",
        "users.roles.label": "Rollen",
        "users.phone": "Telefonnummer",
        "users.notify": "SMS-Alarme",
        "users.role.ADMIN": "Verwalter",
        "users.role.OWNER": "Super User",
        "users.role.EDITOR": "Sachbearbeiter",
        "users.role.ASSISTANT": "Assistent",
        "users.role.READER": "Lesender Nutzer",
        "users.creationTime": "Erstellt",
        "users.lastSignInTime": "Angemeldet",
        'users.resetPassword.label': 'Passwort zurücksetzen',
        'users.resetPassword.success': 'E-Mail zum Zurücksetzen des Passworts gesendet',
        'users.resetPassword.error': 'Es ist ein Fehler aufgetreten. Beachten Sie die weiteren Hinweise',
        'users.changeUserStatus.label.enable': 'Benutzer aktivieren',
        'users.changeUserStatus.label.disable': 'Benutzer deaktivieren',
        'users.changeUserStatus.action.enable.success': 'Benutzer wurde aktiviert',
        'users.changeUserStatus.action.disable.success': 'Benutzer wurde deaktiviert',
        'users.changeUserStatus.error': 'Es ist ein Fehler aufgetreten. Beachten Sie die weiteren Hinweise',
        'users.error.validation': 'Es sind nicht alle Daten eingegegen oder Daten entsprechen nicht dem benötigten Format.',
        'users.message.onRowUpdate.success': 'Benutzer wurde erfolgreich angepasst',
        'users.message.onRowUpdate.error': 'Es ist ein Fehler aufgetreten. Beachten Sie die weiteren Hinweise',
        'users.message.onRowAdd.success': 'Benutzer wurde erfolgreich angelegt',
        'users.message.onRowAdd.error': 'Es ist ein Fehler aufgetreten. Beachten Sie die weiteren Hinweise',
        'users.message.onRowDelete.success': 'Benutzer wurde erfolgreich gelöscht',
        'users.message.onRowDelete.error': 'Es ist ein Fehler aufgetreten. Beachten Sie die weiteren Hinweise',

        "quality.ref": "Gerät",
        "quality.type": "Auffälligkeit",
        "quality.finding": "Auffälligkeit",
        "quality.details": "Weitere Hinweise",
        "quality.created": "Aufgetreten am",
        "quality.measured": "Tatsächlich",
        "quality.expected": "Erwartet",
        "quality.status": "Gerätestatus",
        "quality.site": "Standort",
        "quality.firmware": "Firmware-Version",
        "quality.battery": "Batteriezustand",

        "quality.findingType.LOW_BATTERY": "Batterieladung gering",
        "quality.findingType.LATE_RESPONSE": "Spülung überfällig",
        "quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_POINTS_LO": "Anzahl der Messpunkte zu gering",
        "quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_POINTS_HI": "Anzahl der Messpunkte zu hoch",
        "quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_ML_NULL": "Kein Durchfluss",
        "quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_ML_LO": "Durchfluss zu gering",
        "quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_ML_HI": "Durchfluss zu hoch",
        "quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_MAX_DISTANCE_NULL": "Maximaler Abstand 0 mm",
        "quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_MIN_DISTANCE_NULL": "Minimaler Abstand 0 mm",
        "quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_DISTANCE_HI": "Abstand unplausibel hoch",
        "quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_DISTANCE_LO": "Abstand unplausibel niedrig",
        "quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_VARIANCE_HI": "Stark abweichender Abstand (Maximum)",
        "quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_VARIANCE_LO": "Stark abweichender Abstand (Minimum)",
        "quality.findingType.TESTFLUSHES_ONLY": "Nur Testspülungen",

    }
};

export const materialTableLocalizationDE = {
    pagination: {
        labelDisplayedRows: '{from}-{to} von {count}',
        labelRowsSelect: "Zeilen",
        labelRowsPerPage: "Zeilen pro Seite:",
        firstTooltip: "Erste Seite",
        previousTooltip: "Vorherige Seite",
        lastTooltip: "Letzte Seite",
        nextTooltip: "Nächste Seite",

    },
    header: {
        actions: 'Aktionen'
    },
    body: {
        emptyDataSourceMessage: 'Keine Einträge gefunden',
        addTooltip: 'Hinzufügen',
        deleteTooltip: 'Löschen',
        editTooltip: 'Bearbeiten',
        filterRow: {
            filterTooltip: 'Filter'
        },
        editRow: {
            deleteText: 'Möchten Sie diesen Einträg wirklich löschen?',
            saveTooltip: 'OK',
            cancelTooltip: 'Abbrechen'
        }
    },
    toolbar: {
        searchTooltip: "Suchen",
        nRowsSelected: '{0} Zeilen ausgewählt',
        searchPlaceholder: "Suchen",
        addRemoveColumns: "Spalten hinzufügen oder entfernen",
        showColumnsTitle: "Spalten anzeigen",
        exportName: "Als CSV"
    }
}

intl.init({
    currentLocale: i18nConfig.locale,
    locales: {
        [i18nConfig.locale]: i18nConfig.messages
    },
});


export const get = (id, values) => {

    if (intl.get(id)) {

        let text = intl.get(id);

        if (values) {
            for (const key of Object.keys(values)) {
                text = text.split(`##${key}##`).join(values[key]);
            }
        }

        return text;

    } else {
        return `$$${id}$$`
    }

}

export const getLocalization = (custom) => {
    return custom ? { ...materialTableLocalizationDE, ...custom } : { ...materialTableLocalizationDE }
}